import Navbar from './sections/navbar/Navbar';
import Header from './sections/header/Header';
import About from './sections/about/About';
import Services from './sections/services/Services';
import Portfolio from './sections/portfolio/Portfolio';
import Experience from './sections/experience/Experience';
import Testimonials from './sections/testimonials/Testimonials';
import FAQS from './sections/faqs/FAQS';
import Contact from './sections/contact/Contact';
import Footer from './sections/footer/Footer';
import FloatingNav from './sections/floating.nav/FloatingNav';
import Theme from './theme/Theme';
import { useThemeContext } from './context/theme-context';
import {useRef, useState, useEffect, useCallback} from 'react';

const App = () => {
  const mainRef = useRef();
  const {themeState} = useThemeContext();
  const [showFloatingNav, setShowFloatingNav] = useState(true);
  const [siteYPosition, setSiteYPosition] = useState(0);
  const showFloatingNavHandler = () => {
    setShowFloatingNav(true);
  }
  const hideFloatingNavHandler = () => {
    setShowFloatingNav(false);
  }

  // check if floating nav should be shown or hidden
  const floatingNavToggleHandler = useCallback(() => {
    if(siteYPosition < (mainRef?.current?.getBoundingClientRect().y -20) || siteYPosition > (mainRef?.current?.getBoundingClientRect().y +20)){
      showFloatingNavHandler();
    } else {
      hideFloatingNavHandler();
    }
    setSiteYPosition(mainRef?.current?.getBoundingClientRect().y); 
  }, [siteYPosition]);

    useEffect(() => { 
      const checkYPosition = setInterval(floatingNavToggleHandler, 2000);
    return () => clearInterval(checkYPosition);}, [floatingNavToggleHandler])

  return (
    <main className={`${themeState.primary} ${themeState.background}`} ref={mainRef}>
      <Navbar/>
      <Header/>
      <About/>
      <Services/>
      <Portfolio/>
      <Experience/>
      <Testimonials/>
      <FAQS/>
      <Contact/>
      <Footer/>
      <Theme/>
      {showFloatingNav && <FloatingNav/>}

    </main>
  )
}

export default App